import healthyBW from './healthyIconB&W.svg';
import healthyIconColored from './healthyIconColored.svg';
import lowProbabilityBW from './lowProbabilityIconB&W.svg';
import lowProbabilityIconColored from './lowProbabilityIconColored.svg';
import missingBW from './missingIconB&W.svg';
import missingIconColored from './missingIconColored.svg';
import treatedBW from './treatedIconB&W.svg';
import treatedIconColored from './treatedIconColored.svg';
import unhealthyBW from './unhealthyIconB&W.svg';
import unhealthyIconColored from './unhealthyIconColored.svg';

export const BWIcons = {
  missing: missingBW,
  unhealthy: unhealthyBW,
  healthy: healthyBW,
  treated: treatedBW,
  lowProbability: lowProbabilityBW,
};

export const ColoredIcons = {
  missing: missingIconColored,
  unhealthy: unhealthyIconColored,
  healthy: healthyIconColored,
  treated: treatedIconColored,
  lowProbability: lowProbabilityIconColored,
};
